import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter024() {
  return <KbChapterPage slug="chapter-024" />;
}

(Chapter024 as unknown as { path: string }).path = "/theory-album/024";
